interface SectionHeadingProps {
  index: string;
  eyebrow: string;
  title: string;
  description?: string;
}

export default function SectionHeading({
  index,
  eyebrow,
  title,
  description,
}: SectionHeadingProps) {
  return (
    <div className="border-t border-foreground-950/15 pt-6 md:pt-8">
      <div className="flex items-center gap-3">
        <span className="font-heading text-xs tracking-[0.35em] text-primary-600">
          {index}
        </span>
        <span className="text-xs tracking-[0.3em] text-foreground-500 uppercase">
          {eyebrow}
        </span>
      </div>
      <div className="mt-4 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <h2 className="font-heading text-2xl leading-tight text-foreground-950 md:text-3xl lg:text-[2.35rem]">
          {title}
        </h2>
        {description ? (
          <p className="max-w-xl text-sm leading-7 text-foreground-600 md:text-[15px]">
            {description}
          </p>
        ) : null}
      </div>
    </div>
  );
}